// src/context/ToastContext.jsx
import React, { createContext, useContext, useState, useCallback } from "react";
import { Snackbar, Alert, Slide } from "@mui/material";

const Ctx = createContext(null);
let _id = 0;
const Up = (p) => <Slide {...p} direction="up" />;

export function ToastProvider({ children }) {
  const [list, setList] = useState([]);
  const push = useCallback((msg, severity = "info", dur = 3500) => {
    const id = ++_id;
    setList((p) => [...p, { id, msg, severity, open: true }]);
    setTimeout(() => setList((p) => p.filter((t) => t.id !== id)), dur + 600);
  }, []);
  const close = (id) => setList((p) => p.map((t) => t.id === id ? { ...t, open: false } : t));
  const toast = {
    success: (m, d) => push(m, "success", d),
    error:   (m, d) => push(m, "error",   d ?? 5000),
    warning: (m, d) => push(m, "warning", d),
    info:    (m, d) => push(m, "info",    d),
  };
  return (
    <Ctx.Provider value={toast}>
      {children}
      {list.map((t, i) => (
        <Snackbar key={t.id} open={t.open} TransitionComponent={Up}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          sx={{ bottom: { xs: 16 + i * 68, sm: 24 + i * 68 } }}>
          <Alert severity={t.severity} variant="filled" onClose={() => close(t.id)}
            sx={{ minWidth: 270, fontWeight: 600, borderRadius: "10px", boxShadow: "0 8px 24px rgba(0,0,0,.15)" }}>
            {t.msg}
          </Alert>
        </Snackbar>
      ))}
    </Ctx.Provider>
  );
}

export function useToast() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useToast must be inside <ToastProvider>");
  return ctx;
}
